import type { BuildingCoreSections } from "../../../types/buildings-sections/core";

export const buildingCore: BuildingCoreSections = {
  title: "Buildings",
  addNew: "Add New",
  edit: "Edit Building",
  name: "Building Name",
  address: "Address",
  typeLabel: "Building Type",
  yearBuilt: "Year Built",
  netArea: "Net Area",
  plotArea: "Plot Area (m²)",
  costPerSquareMeter: "Cost per m²",
  description: "Description",
  save: "Save",
  cancel: "Cancel",
  updated: "Building data updated",
  nameUpdated: "Building name successfully updated",
  error: "Error updating building data",
  loading: "Loading buildings...",
  empty: "No buildings found",
  nameRequired: "Building name is required",
  addressRequired: "Address is required",
  yearRequiredNumeric: "Year must be a number",
  areaRequiredNumeric: "Area must be a number",
  formErrors: "Please fix errors in the form",
  buildingDetail: "Building Details",
  buildingNotFound: "Building not found",
  selectBuilding: "Select Building",
  typeRequired: "Building type is required",
  location: "Location",
  constructionType: "Construction Type",
  registryCode: "Building Registry Code",
  registryCodeInvalid: "Registry code must be exactly 9 digits",
  cadastralCode: "Cadastral Unit Code",
  cadastralCodeInvalid: "Cadastral unit code must be in format XXXXX:XXX:XXXX",
  kinnistuNumber: "Property Number",
  kinnistuNumberInvalid: "Property number must contain only digits (1–10 characters)",
  kinnistuNumberExists: "This property number is already in use",
  plotAreaInvalid: "Plot area must be a positive number with up to two decimal places",
  plotAreaRequired: "Plot area is required",
  constructionTypes: {
    office: "Office",
    retail: "Retail",
    residential: "Residential",
    logistics: "Logistics",
    industrial: "Industrial",
    healthcare: "Healthcare",
    educational: "Educational",
    hospitality: "Hospitality",
    mixed_use: "Mixed Use",
    data_center: "Data Center",
    other: "Other",
  },
  formSections: {
    landAndRegistry: "Land and Registry Data",
    generalInformation: "General Information",
    buildingAreasVolumes: "Building Areas and Volumes",
    buildingRightsPlanning: "Building Rights and Planning",
    parkingMobility: "Parking and Mobility",
    utilitiesTechnical: "Utilities and Technical Systems",
    certificatesQuality: "Certificates and Quality Marks",
  },
  certifications: {
    title: "Building Certifications",
    addCertificate: "Add Certificate",
    certificateType: "Certificate Type",
    certificateValue: "Value/Level",
    noCertificates: "No certificates added yet",
    selectType: "Select certificate type...",
  },
};
